import { Typography } from '@mui/material';
import Bazzar from '../components/Bazzar';

function BazzarPage() {
    return (
        <>
            <Typography variant="h4" gutterBottom>Bazzar</Typography>
            <Bazzar />
        </>
    );
}

export default BazzarPage;
